var map = {
	"./ar/media/index.vue": [
		2940,
		8568,
		2940
	],
	"./bn/media/index.vue": [
		6491,
		8568,
		8872
	],
	"./en/media/index.vue": [
		3673,
		8568,
		3673
	],
	"./fa/media/index.vue": [
		9938,
		8568,
		9938
	],
	"./ur/media/index.vue": [
		3577,
		8568,
		3577
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 6673;
module.exports = webpackAsyncContext;